import { PauseIcon, PlayIcon } from "@heroicons/react/24/solid";
import { FC } from "react";

export type PlayOverlaySize = "m" | "md" | "lg";

const PLAY_OVERLAY_SIZE: Record<
  PlayOverlaySize,
  { disc: string; icon: string }
> = {
  // Grid cards / inline review — mirrors Button size "m" (36px disc, 20px glyph).
  m: { disc: "h-9 w-9", icon: "h-5 w-5" },
  // Mirrors Button size "l" (44px disc, 24px glyph).
  md: { disc: "h-11 w-11", icon: "h-6 w-6" },
  // Full player center control (result/editor players, touch).
  lg: { disc: "h-16 w-16", icon: "h-8 w-8" },
};

// The shared circular play/pause overlay disc used across every video surface:
// the result/editor player's touch center control and the Create-shorts grid
// cards (rest-state play + inline review). Presentational only — callers own the
// clickable wrapper (positioning, opacity reveal, onClick) so the disc itself
// stays identical everywhere.
const PlayOverlay: FC<{
  /** Show the pause glyph instead of play. */
  playing?: boolean;
  /** @default "md" */
  size?: PlayOverlaySize;
  className?: string;
}> = ({ playing = false, size = "md", className = "" }) => {
  const s = PLAY_OVERLAY_SIZE[size];
  return (
    <span
      className={`flex items-center justify-center rounded-full bg-black/50 text-white ${s.disc} ${className}`}
    >
      {playing ? (
        <PauseIcon className={s.icon} />
      ) : (
        <PlayIcon className={s.icon} />
      )}
    </span>
  );
};

export default PlayOverlay;
